export default __webpack_public_path__ + "static/media/Bangles-Making-Charge-List.a1782d0b.jpg";